module.exports = __webpack_public_path__ + "static/benefits-img6-ea440adbe4869a72e6227841f2740180.png";